import extend from 'extend'

const profile = {
  // 图片域名
  imgDomain: ''
}

// 允许覆盖默认配置
export const merge = (opts = {}) => {
  extend(true, profile, opts)
}

export default profile



// WEBPACK FOOTER //
// ./src/packages/profile/index.js